import React from 'react'
import ModalWrapper from '../ModalWrapper'
import RemoveBackupEmailContainer from '../../../containers/account/RemoveBackupEmailContainer'

const RemoveBackupEmailModal = (props) => {
  const { hideModal } = props
  return (
    <div className='accountAuthentication-modal'>
      <ModalWrapper
        title='Remove Backup Email'
        modalStyle='dark'
        hideModal={hideModal}
        closeBtn={false}
      >
        <RemoveBackupEmailContainer hideModal={hideModal} />
      </ModalWrapper>
    </div>
  )
}

export default RemoveBackupEmailModal
